// @flow strict
/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
import * as React from 'react';
import type { ReportFormDispatcher, SubmissionForm } from './useReportForm';
import type { IAPReason } from './IAPReason';
import CommentBox from './CommentBox';
import forLabel from './IAPReason';
import ReportIAPRadio from './ReportIAPRadio';

type Props = {|
  selected: IAPReason | null,
  reason: IAPReason,
  comment?: string,
  dispatch: ReportFormDispatcher,
  minLength?: number,
  maxLength?: number,
|};

/** Returns a validator which validates a comment's length */
export const useLengthValidator = (minLength: number, maxLength: number) =>
  React.useCallback(
    (form: SubmissionForm) => {
      const trimmedValue = (form.comment || '').trim();
      if (trimmedValue.length > maxLength) {
        return false;
      }
      if (trimmedValue.length < minLength) {
        return false;
      }
      return true;
    },
    [minLength, maxLength],
  );

const CommentOption = ({
  selected,
  reason,
  comment = '',
  dispatch,
  minLength = 0,
  maxLength = 250,
}: Props) => {
  const validator = useLengthValidator(minLength, maxLength);
  return (
    <ReportIAPRadio
      value={reason}
      selected={selected === reason}
      labelText={forLabel(reason).label}
      onSelect={() => {
        dispatch({ type: 'changeReason', payload: { reason, validator } });
      }}
    >
      <CommentBox
        value={comment}
        onChange={event => {
          dispatch({ type: 'modifyBody', payload: { comment: event.currentTarget.value } });
        }}
        minLength={minLength}
        maxLength={maxLength}
        required={!!minLength}
      />
    </ReportIAPRadio>
  );
};

export default CommentOption;
